export default __webpack_public_path__ + "static/media/Minor Brew of Fortitude.913d4642.jpg";